// SectionSubOntotitaList.tsx
import React, { useState, useMemo } from 'react';
import { Ontotis } from '../../../utils/types';
import { CONFIG } from '../../../utils/config';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { authService } from '../../../utils/authServices';

interface SubServicesProps {
  Ontotis: Ontotis[]; // unit should be an array of Unit objects
  subontotisname:string;
  canedit:boolean;
  parentid?:string;
  address?:string;
   tk?:string;
   city?:string;
  
}

const SectionSubOntotitaList: React.FC<SubServicesProps> = ({ Ontotis = [], parentid, address, tk, city, subontotisname, canedit }) => {
  const userRole = authService.getPrimaryRole();
  const navigate = useNavigate(); // Initialize useNavigate
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
  const location = useLocation();
  const [path, setPath] = useState<string | null>(null);
  // Check if 'unit' is a valid array
  const services = Array.isArray(Ontotis) ? Ontotis : [];


 // const currentPath = location.pathname;

//console.log('currentPath:', currentPath); // Debugging


  const handleAddClick = () => {
    

    navigate(CONFIG.urls.getOntotitaAddUrl_Admin(), {
      state: {
        id: parentid!,
        address:address,
        tk:tk,
        city:city,
        returnTo: CONFIG.urls.getOntotitaViewUrl_Admin(parentid!)
      },
    });
  };
  const handleEditClick = (id: any)  => {
    //const currentPath = location.pathname;

   // navigate(CONFIG.urls.getOntotitaEditUrl_Admin(id!))

   navigate(CONFIG.urls.getOntotitaEditUrl_Admin(id!), {
    state: { returnTo: CONFIG.urls.getOntotitaViewUrl_Admin(id!),returnToDel: CONFIG.urls.getOntotitaViewUrl_Admin(parentid!) },
  });
  };

  const handleClick = (newId: string) => {
    // Get the current path segments
    const currentPath = location.pathname.split('/').filter(Boolean);

    // Append the new ID to the current path
    const newPath = [...currentPath, newId];

    // Construct the dynamic path
    const dynamicPath = CONFIG.urls.getDynamicOntotitaUrl(newPath);

    // Navigate to the new path
    navigate(dynamicPath, {
      state: {
        id: newId,
        fullPath: dynamicPath,
      },
    });
  };



  const sortedData = useMemo(() => {
    let sortableData = [...Ontotis];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        let aValue: any;
        let bValue: any;

        switch (sortConfig.key) {
          case 'title':
            aValue = a.title?.trim().toLowerCase() ?? '';
            bValue = b.title?.trim().toLowerCase() ?? '';
            break;
          default:
            return 0;
        }

        if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [Ontotis, sortConfig]);

  const requestSort = (key: 'title') => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
 

  return (
    <section className="sub-services py-5 ">
    <div className="container bg-white rounded-4 p-5">
         {/* ADD */}
         <div className="row align-items-center">
              {/* Heading */}
              <div className="col-md-9 ">
              <h2 className="h5 mb-4 text-danger">
                {subontotisname && subontotisname !== '0' ? subontotisname : "Υπηρεσίες"}
              </h2>
    
              </div>

              {/* Button aligned right */}
              <div className="col-md-3 text-md-end p-2">
              {userRole === 'admin' && (
                <button className="btn btn-success btn-sm mb-4" onClick={() => handleAddClick()}>
                  <i className="bi bi-plus me-1"></i> Προσθήκη
                </button>
                )}
              </div>
            </div>
          
   

    
    {/* Check if 'services' list is empty */}
    {sortedData.length === 0 ? (
      <p className="text-center text-muted">Δεν υπάρχουν πληροφορίες</p>
    ) : (
      <div >
       <div className="p-3 bg-white rounded-2 border border-1 table-responsive">
           <table className="table w-100 m-0 table-borderless table table-striped" >
                    
            <thead>
              <tr>
              <th className="sortable" onClick={() => requestSort('title')}>
           
                  Τίτλος <i className="bi bi-arrow-down-up text-muted ms-1">
               </i>
              </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((item, index) => (
                <tr key={index}>
                    <td> <a href={CONFIG.urls.getOntotitaViewUrl_Admin(item.id!!)}  style={{ textDecoration: "none" }}>
                  {item.title}
                </a></td>
                
                  <td className="text-end">
                  <button     onClick={() => handleClick(item.id?.toString()|| '')} className="btn btn-secondary btn-sm">
                    <i className="bi bi-eye me-1"></i> Προβολή
                  </button>
                  {userRole === 'admin' && (
                 // {(item.can_edit !== undefined && item.can_edit === true) && (
                      <button
                        onClick={() => handleEditClick(item.id?.toString() || '')}
                        className="btn btn-warning btn-sm ms-2"
                      >
                        <i className="bi bi-pencil me-1"></i> Επεξεργασία
                      </button>
                    )}


                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
</section>

    
  );
};

export default SectionSubOntotitaList;

